import { Box } from '@mui/material';
import { ODSButton } from '@telekom-ods/react-ui-kit';
import { useIntl } from 'react-intl';

import Tooltip from '../Tooltip';

interface ActionItem {
  label: string;
  onClick: (value: CellValue) => void;
  tooltip?: string;
  disabled?: boolean;
}

interface CellValue {
  organizationId: string;
  name?: string;
  description?: string;
  businessUnitId?: string;
  technicalLeadId?: string;
  _id: string;
}

interface ActionCell {
  value: CellValue;
  actions?: ActionItem[] | undefined;
}

interface ActionProps {
  cell: ActionCell;
}

const Action = ({ cell }: ActionProps) => {
  const intl = useIntl();

  const handleEditAction = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const { actions, value } = cell;
    const editAction = actions?.[0];
    if (editAction && !editAction.disabled && typeof editAction.onClick === 'function') {
      editAction.onClick(value);
    }
  };

  const handleDeleteAction = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const { actions, value } = cell;
    const deleteAction = actions?.[1];
    if (deleteAction && !deleteAction.disabled && typeof deleteAction.onClick === 'function') {
      deleteAction.onClick(value);
    }
  };

  const { actions } = cell;
  return (
    <Box
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
      }}
      sx={{ display: 'inline-flex', gap: '4px' }}
    >
      <Tooltip
        title={
          actions?.[0]?.disabled && actions[0].tooltip
            ? intl.formatMessage({ id: actions[0].tooltip })
            : ''
        }
      >
        <ODSButton
          buttonType='iconOnly'
          size='small'
          buttonIcon='edit-type-standard'
          variant='ghost'
          onClick={handleEditAction}
          disabled={actions?.[0]?.disabled ?? false}
        />
      </Tooltip>
      <Tooltip
        title={
          actions?.[1]?.disabled && actions[1].tooltip
            ? intl.formatMessage({ id: actions[1].tooltip })
            : ''
        }
      >
        <ODSButton
          buttonType='iconOnly'
          size='small'
          buttonIcon='delete-type-standard'
          variant='ghost'
          onClick={handleDeleteAction}
          disabled={actions?.[1]?.disabled ?? false}
        />
      </Tooltip>
    </Box>
  );
};

export default Action;
